<template>
  <div class="container-custom">
    <div
      class="table-responsive"
      v-if="clientBalance.balance"
    >
      <h2>Текущий баланс</h2>
      <table class="table is-bordered">
        <thead>
        <tr>
          <th>Ресурс</th>
          <th>Значение</th>
        </tr>
        </thead>
        <tbody>
        <tr
          v-for="(value, name) in clientBalance.balance"
          :key="name"
        >
          <td class="td-resource">{{ name }}</td>
          <td class="td-value">{{ value }}</td>
        </tr>
        </tbody>
      </table>
    </div>

    <div
      class="table-responsive"
      v-if="clientBalance.creditLimit"
    >
      <h2> Кредитный лимит </h2>
      <table class="table is-bordered is-striped is-narrow">
        <thead>
        <tr>
          <th>Ресурс</th>
          <th>Значение</th>
        </tr>
        </thead>

        <tbody>
        <tr
          v-for="(value, name) in clientBalance.creditLimit"
          :key="name"
        >
          <td class="td-resource ">{{ name }}</td>
          <td class="td-value">{{ value }}</td>
        </tr>
        </tbody>

      </table>
    </div>

    <div
      class="table-responsive"
      v-if="replenishmentResourcesPage && replenishmentResourcesPage.content"
    >
      <h2>Пополнения</h2>
      <table class="table is-bordered is-striped is-narrow">
        <thead>
        <tr>
          <th>
            Дата пополнения
          </th>
          <th>
            Пополняемые ресурсы
          </th>
        </tr>
        </thead>
        <tbody>
        <tr
          v-for="(addResource) in replenishmentResourcesPage.content"
          :key="addResource.id"
        >
          <td class="date">
            {{
              getDateFormat((addResource.timestampUtcMillis / 1000) < 1000000000000 ? addResource.timestampUtcMillis : addResource.timestamp / 1000)
            }}
          </td>
          <td>
            <div class="table-responsive">
              <table class="table is-bordered">
                <thead>
                <tr>
                  <th>Ресурс</th>
                  <th>Значение</th>
                </tr>
                </thead>
                <tbody>
                <tr
                  v-for="(value, name) in addResource.resources"
                  :key="name"
                >
                  <!-- skip zero valued resources -->
                  <td
                    class="td-resource "
                    v-if="value"
                  >{{ name }}
                  </td>
                  <td
                    class="td-value"
                    v-if="value"
                  >{{ value }}
                  </td>
                </tr>
                </tbody>
              </table>
            </div>
          </td>
        </tr>
        </tbody>
      </table>
    </div>
    <div class="paging-bottom">
      <Paging
        :refresh="loadReplenishmentResourcesPage"
        :per-page="replenishItemsPerPage"
        :data.sync="replenishmentResourcesPage"
        :pagingClass="'bottom'"
      />
    </div>
  </div>
</template>

<script>
const BILLING_API = 'billing/clientBalance'
const CLIENTS_API = '/api/clients'

import {mapGetters} from 'vuex'
import Paging from '../components/Paging'
import VisCommon from '../components/VisCommon'

export default {
  name: 'Balance',
  extends: VisCommon,
  components: {
    Paging
  },
  data() {
    return {
      replenishmentResourcesPage: {content: []},
      replenishItemsPerPage: 8,
      title: '',
      clientBalance: {},
      loading: false,
      currentSort: 'timestampUtcMillis',
      currentSortDir: 'desc'
    }
  },
  created: function () {
    this.loadReplenishmentResourcesPage()
    this.loadClientBalance()
  },

  computed: {
    ...mapGetters([
      'authenticationToken',
      'clientId'
    ])
  },
  methods: {
    prepareSecurityHeader() {
      return {
        Authorization: `Bearer ${this.authenticationToken}`
      }
    },
    loadReplenishmentResourcesPage(page) {
      let that = this
      this.loading = true
      page = page ? (page - 1) : 0
      let url = BILLING_API + '/getAddResourcesList/' + this.clientId + '?page=' + page + '&pageSize=' + this.replenishItemsPerPage + '&sortDir=' + 'desc' + '&sort=' + 'timestampUtcMillis'
      this.$http.get(url, {headers: this.prepareSecurityHeader()})
        .then((response) => {
          that.loading = false
          that.replenishmentResourcesPage = response.data
        })
        .catch((error) => {
          that.loading = false
          console.log(error)
          that.openNotificationWithType('danger', 'Ошибка загрузки списка пополнений. ')
        })
    },

    loadClientBalance: function () {
      let that = this
      this.loading = true
      this.$http.get(CLIENTS_API + '/getClient/' + this.clientId, {headers: this.prepareSecurityHeader()})
        .then((response) => {
          that.loading = false
          that.clientBalance = response.data.clientBalance
        })
        .catch((error) => {
          console.log(error)
          this.openNotificationWithType('danger', 'Ошибка загрузки данных клиента. ')
        })
    }
  }
}
</script>

<style scoped>
th div {
  display: inline-block;
}

.td-value {
  text-align: center;
}

.td-resource {
  font-weight: 600;
}

.table-responsive h2 {
  text-align: center;
  font-weight: bold;
  font-size: large;
}
</style>




// WEBPACK FOOTER //
// Balance.vue?04e735ba